import { render, staticRenderFns } from "./NormalSearchNav401.vue?vue&type=template&id=fa8621a8&scoped=true"
import script from "./NormalSearchNav401.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav401.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8621a8",
  null
  
)

export default component.exports